export const sampleMarkdown = `# Markdown Studio

Write Markdown on the left. The preview updates instantly on the right.

## Formatting

- **Bold**, *italic*, and ~~strikethrough~~
- [Links](https://commonmark.org)
- Inline code like \`const ready = true\`
- Task lists:
  - [x] Build the editor
  - [ ] Export the final draft

> A focused writing surface with just enough tooling nearby.

## Table

| Feature | Status |
| --- | --- |
| Live preview | Ready |
| Local drafts | Ready |
| PDF / HTML / MD export | Ready |

## Code

\`\`\`ts
type DocumentState = {
  title: string;
  saved: boolean;
};

const autosave = (document: DocumentState) => ({
  ...document,
  saved: true,
});
\`\`\`

## Mermaid

\`\`\`mermaid
sequenceDiagram
  participant U as User
  participant E as Editor
  participant P as Preview
  U->>E: Type Markdown
  E->>P: Update document state
  P-->>U: Render diagram
\`\`\`

---

Drag an image onto the editor to insert it as Markdown.`;
